<template>
  <div id="saving-compare">
    <h3>ผลตอบแทน 1 ปี</h3>
    <div id="chart-title">
      <div class="chart-label">
        <i class="fas fa-rectangle-landscape"></i>
        ออมทรัพย์
        <br />
        <i class="fas fa-rectangle-landscape hidden"></i>
        ({{ savingRate | percent }})
      </div>
      <div class="chart-label">
        <i class="fas fa-rectangle-landscape"></i>
        ฝากประจำ
        <br />
        <i class="fas fa-rectangle-landscape hidden"></i>
        ({{ fixedRate | percent }})
      </div>
      <div class="chart-label">
        <i class="fas fa-rectangle-landscape"></i>
        แผน Plus
        <br />
        <i class="fas fa-rectangle-landscape hidden"></i>
        ({{ returnRate | percent }})
      </div>
    </div>

    <div id="chart-wraper">
      <div id="chart">
        <canvas id="saving-compare-chart"></canvas>
      </div>
      <div id="description">
        <div>
          <i class="fas fa-rectangle-landscape"></i>
          +{{ saving | number }}
        </div>
        <div>
          <i class="fas fa-rectangle-landscape"></i>
          +{{ fixed | number }}
        </div>
        <div>
          <i class="fas fa-rectangle-landscape"></i>
          +{{ plus | number }}
        </div>
      </div>
    </div>
    <div id="disclaimer">
      <p>*ผลตอบแทนที่แสดงเป็นผลตอบแทนย้อนหลัง 1 ปี (หลังหักภาษี) ในอดีต ซึ่งไม่ได้เป็นการการันตีผลตอบแทนในอนาคต</p>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import InterestRate from "../../config/interest-rate.json";
import PlusConfig from "../../config/plus-config.json";
import axios from "axios";

export default {
  name: "saving-compare",
  props: {
    initial: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      chart: null,
      fixedRate: InterestRate.fixed,
      savingRate: InterestRate.saving,
      returnRate: 2,
      saving: 0,
      fixed: 0,
      plus: 0
    };
  },
  watch: {
    initial: {
      handler(data) {
        if (this.chart) {
          this.updateChart(data);
        }
      },
      deep: true
    }
  },
  filters: {
    number: function(value) {
      return Number(value).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    percent: function(value) {
      if (value) {
        return Number(value).toFixed(2) + "%";
      }

      return "-";
    }
  },
  created() {},
  async mounted() {
    try {
      let { data } = await axios.get(
        `/api/fund/public/${PlusConfig.fund_id}/overview`
      );

      if (data && data.total_return_1y) {
        this.returnRate = data.total_return_1y;
      }
    } catch (err) {
      // do nothing
    }

    await this.createChart();
  },
  methods: {
    async createChart() {
      var ctx = document
        .getElementById("saving-compare-chart")
        .getContext("2d");
      this.chart = new Chart(ctx, {
        type: "horizontalBar",
        scaleStartValue: 0,
        data: {
          labels: ["ออมทรัพย์", "ฝากประจำ", "แผน Plus"],
          datasets: [
            {
              data: [0, 0, 0],
              backgroundColor: ["#afafaf", "#868686", "#f7a501"],
              borderColor: ["#afafaf", "#868686", "#f7a501"],
              borderWidth: 1
            }
          ]
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: false,
            fontSize: 10
          },
          layout: {
            padding: {
              left: -12,
              right: 12,
              top: 12,
              bottom: 0
            }
          },
          scales: {
            yAxes: [
              {
                gridLines: {
                  display: false
                },
                ticks: {
                  beginAtZero: true,
                  display: false
                }
              }
            ],
            xAxes: [
              {
                gridLines: {
                  display: false
                },
                ticks: {
                  maxTicksLimit: 5,
                  fontSize: 10,
                  fontColor: "#999999",
                  beginAtZero: true,
                  userCallback: function(value) {
                    return Number(value).toLocaleString();
                  }
                }
              }
            ]
          }
        }
      });
      this.updateChart(this.initial);
    },
    updateChart(initial) {
      this.plus = (initial * this.returnRate) / 100;
      this.fixed = (initial * this.fixedRate) / 100;
      this.saving = (initial * this.savingRate) / 100;

      this.chart.data.datasets[0].data[2] = this.plus;
      this.chart.data.datasets[0].data[1] = this.fixed;
      this.chart.data.datasets[0].data[0] = this.saving;

      this.$emit("return", this.plus);

      this.chart.update();
    }
  }
};
</script>



<style lang="scss" scoped>
#saving-compare {
  padding: 0px 16px;
  h3 {
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  #chart-title {
    padding: 0px 0px 0px 5px;
    margin-top: 18px;
    font-size: 14px;
    display: flex;

    .chart-label {
      text-align: left;
      line-height: 18px;

      padding-right: 1.8em;
      @media only screen and (max-width: 320px) {
        padding-right: 8px;
      }

      .hidden {
        visibility: hidden;
      }

      margin: 0;
      i {
        margin-right: 5px;
      }
    }

    div:nth-child(1) {
      i {
        color: #afafaf;
      }
    }
    div:nth-child(2) {
      i {
        color: #868686;
      }
    }
    div:nth-child(3) {
      i {
        color: #f7a501;
      }
    }
  }
  #chart-wraper {
    display: flex;

    #chart {
      width: calc(100% - 128px);
    }

    #description {
      padding-top: 14px;
      padding-left: 8px;
      font-size: 14px;
      width: 128px;

      div {
        padding: 3px;
        display: inline-block;
      }

      div:nth-child(1) {
        color: #868686;
        i {
          color: #afafaf;
        }
      }
      div:nth-child(2) {
        color: #868686;
      }
      div:nth-child(3) {
        padding: 6px;
        font-size: 16px;
        font-weight: bold;
        i {
          color: #f7a501;
        }
        border-radius: 4px;
        border: solid 1px #e4e8ea;
        background-color: #fcfcfc;
        color: #17c161;
      }
    }
  }
  #disclaimer {
    p {
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $color-secondary-text;
    }
  }
}
</style>



